import { useQuery } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { vodUrl } from '../../../../client-config.js';

/**
 * The dashboard FAB videos vod resolves for a page of the org the user is in,
 * given every ROUTES key that matches the page (none for a page that matches no
 * ROUTES key, which only gets the videos without routes), as
 * `{ orgId, videos: [{ id, hideWhenWatched, hideWhenDismissed, orientation }] }`,
 * where orientation is 'landscape' or 'portrait'.
 */
const useDashboardFabQuery = ({ orgId, routeKeys = [], enabled = true }) => {
  const firebase = useFirebase();

  return useQuery({
    queryKey: ['dashboardFab', orgId, routeKeys.join(',')],
    queryFn: async () => {
      const idToken = await firebase.getIdToken();
      const url = new URL(`${vodUrl}/v1/orgs/${orgId}/dashboard-fab`);
      if (routeKeys.length > 0) url.searchParams.set('route', routeKeys.join(','));
      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${idToken}` },
        mode: 'cors',
      });
      if (!response.ok) {
        throw new Error(`Failed to fetch dashboard FAB videos: ${response.status}`);
      }
      const { data } = await response.json();
      return data;
    },
    enabled: enabled && !!vodUrl && !!orgId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });
};

export default useDashboardFabQuery;
